module.exports = __webpack_public_path__ + "media/images/top_banner_logo2-77654dc66f2e625ba77d30b639110a85.png";